export const part_file_uploader_strings = {
  // File upload section
  selectFiles: "Select Files",
  dragDropHint: "Drag and drop files here or click to browse",
  unsupportedFileType: "Unsupported file type",

  // File management
  existingFiles: "Existing Files",
  noFilesForCategory: "No files uploaded for this category yet",

  // File actions
  upload: "Upload",
  delete: "Delete",
  cancel: "Cancel",

  // Delete confirmation dialog
  confirmDeleteTitle: "Delete File",
  confirmDeleteMessage: "Are you sure you want to delete this file?",
  confirmDeleteWarning: "This action cannot be undone.",

  // File types
  fileTypes: "Supported file types: PDF, Word, Images, Text",
  files: "files",

  // Status messages
  uploading: "Uploading...",
  deleting: "Deleting...",
  uploadSuccess: "File uploaded successfully",
  deleteSuccess: "File deleted successfully",
  uploadError: "Upload failed",
  deleteError: "Delete failed",

  // File metadata
  fileSize: "Size",
  uploadDate: "Uploaded",
  fileName: "File Name",
};
